module.exports = __webpack_public_path__ + "img/18.4bd72b4c.jpg";